module.exports = {
	"contractName": "Encrypt",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "complete",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_key",
					"type": "uint256"
				}
			],
			"name": "guess",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "pass",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		}
	],
	"bytecode": "0x60806040527f43726f73736c696e6b203230313900000000000000000000000000000000000060005534801561003457600080fd5b50610279806100446000396000f3006080604052600436106100565763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663522e1177811461005b5780639189fec114610084578063a7a1ed721461009e575b600080fd5b34801561006757600080fd5b506100706100b3565b604080519115158252519081900360200190f35b34801561009057600080fd5b5061009c6004356100bc565b005b3480156100aa57600080fd5b50610070610244565b60015460ff1681565b6040805142602080830182905283518084038201815292840193849052825191936000938493849384939182918401908083835b6020831061010f5780518252601f1990920191602091820191016100f0565b51815160209384036101000a60001901801990921691161790526040805192909401829003822042838301819052855180850384018152938601958690528351919b5099509195509293508392850191508083835b602083106101835780518252601f199092019160209182019101610164565b51815160209384036101000a600019018019909216911617905260408051929094018290038220600054438484015285518085038401815293860195869052835191995096509194508392508401908083835b602083106101f55780518252601f1990920191602091820191016101d6565b5181516000196020949094036101000a9390930192831692191691909117905260405192018290039091206001805460ff19169990971816939093169890981495909517909255505050505050565b60015460ff16905600a165627a7a72305820fe4fa0b43e32d7006e621e0e727ccc3aceeed9d9f22f1bbc9d7723c16022fcaf0029",
	"deployedBytecode": "0x6080604052600436106100565763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663522e1177811461005b5780639189fec114610084578063a7a1ed721461009e575b600080fd5b34801561006757600080fd5b506100706100b3565b604080519115158252519081900360200190f35b34801561009057600080fd5b5061009c6004356100bc565b005b3480156100aa57600080fd5b50610070610244565b60015460ff1681565b6040805142602080830182905283518084038201815292840193849052825191936000938493849384939182918401908083835b6020831061010f5780518252601f1990920191602091820191016100f0565b51815160209384036101000a60001901801990921691161790526040805192909401829003822042838301819052855180850384018152938601958690528351919b5099509195509293508392850191508083835b602083106101835780518252601f199092019160209182019101610164565b51815160209384036101000a600019018019909216911617905260408051929094018290038220600054438484015285518085038401815293860195869052835191995096509194508392508401908083835b602083106101f55780518252601f1990920191602091820191016101d6565b5181516000196020949094036101000a9390930192831692191691909117905260405192018290039091206001805460ff19169990971816939093169890981495909517909255505050505050565b60015460ff16905600a165627a7a72305820fe4fa0b43e32d7006e621e0e727ccc3aceeed9d9f22f1bbc9d7723c16022fcaf0029",
	"sourceMap": "26:570:7:-;;;47:40;;;26:570;5:2:-1;;;;30:1;27;20:12;5:2;26:570:7;;;;;;;",
	"deployedSourceMap": "26:570:7:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;91:20;;8:9:-1;5:2;;;30:1;27;20:12;5:2;91:20:7;;;;;;;;;;;;;;;;;;;;;;116:405;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;116:405:7;;;;;;;525:69;;8:9:-1;5:2;;;30:1;27;20:12;5:2;525:69:7;;;;91:20;;;;;;:::o;116:405::-;233:23;;;182:15;233:23;;;;;;;;;26:21:-1;;;22:32;;6:49;;233:23:7;;;;;;;223:34;;182:15;;158:13;;;;;;;;233:23;;;223:34;;;;233:23;223:34;36:153:-1;66:2;58:11;;36:153;;176:10;;164:23;;-1:-1;;139:12;;;;98:2;89:12;;;;114;36:153;;;299:10;344;;263:2;259:12;;;254:3;250:22;-1:-1;;246:30;311:9;;295:26;;;340:21;;377:20;365:33;;223:34:7;;;;;;;;;;;;288:15;339:23;;;;;;;;26:21:-1;;;22:32;;6:49;;339:23:7;;;;;;;329:34;;223;;-1:-1:-1;288:15:7;-1:-1:-1;339:23:7;;-1:-1:-1;339:23:7;;-1:-1:-1;339:23:7;;329:34;;;-1:-1:-1;329:34:7;339:23;329:34;36:153:-1;66:2;58:11;;36:153;;176:10;;164:23;;-1:-1;;139:12;;;;98:2;89:12;;;;114;36:153;;;299:10;344;;263:2;259:12;;;254:3;250:22;-1:-1;;246:30;311:9;;295:26;;;340:21;;377:20;365:33;;329:34:7;;;;;;;;;;;;-1:-1:-1;469:5:7;445:12;428:30;;;;;;26:21:-1;;;22:32;;6:49;;428:30:7;;;;;;;418:41;;329:34;;-1:-1:-1;469:5:7;-1:-1:-1;428:30:7;;-1:-1:-1;428:30:7;;-1:-1:-1;418:41:7;;;;428:30;418:41;36:153:-1;66:2;58:11;;36:153;;176:10;;164:23;;-1:-1;;139:12;;;;98:2;89:12;;;;114;36:153;;;299:10;344;;263:2;259:12;;;;254:3;250:22;-1:-1;;246:30;311:9;;295:26;;;340:21;;377:20;;;;365:33;;418:41:7;;;;;;;;;;274:1:-1;480:36:7;;389:19;;;;388:71;387:87;;;;492:23;;;;-1:-1:-1;;480:36:7;;;;;;;;;;-1:-1:-1;;;;;;116:405:7:o;525:69::-;581:8;;;;525:69;:::o",
	"source": "pragma solidity ^0.4.24;\n\ncontract Encrypt {\n  bytes32 private sault = \"Crosslink 2019\";\n  bool public complete;\n\n  function guess(uint256 _key) public {\n    bytes32 time1 = bytes32(block.timestamp);\n    bytes32 entropy1 = keccak256(abi.encodePacked(time1));\n\n    bytes32 time2 = bytes32(block.timestamp);\n    bytes32 entropy2 = keccak256(abi.encodePacked(time2));\n\n    bytes32 target = ((entropy1 ^ entropy2) &\n      keccak256(abi.encodePacked(block.number))) &\n      sault;\n    complete = (target == bytes32(_key));\n  }\n\n  function pass() public view returns (bool) {\n    return complete;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Encrypt.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Encrypt.sol",
		"exportedSymbols": {
			"Encrypt": [
				992
			]
		},
		"id": 993,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 913,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:7"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 992,
				"linearizedBaseContracts": [
					992
				],
				"name": "Encrypt",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 916,
						"name": "sault",
						"nodeType": "VariableDeclaration",
						"scope": 992,
						"src": "47:40:7",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bytes32",
							"typeString": "bytes32"
						},
						"typeName": {
							"id": 914,
							"name": "bytes32",
							"nodeType": "ElementaryTypeName",
							"src": "47:7:7",
							"typeDescriptions": {
								"typeIdentifier": "t_bytes32",
								"typeString": "bytes32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "43726f73736c696e6b2032303139",
							"id": 915,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "71:16:7",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_308c268d533d8ecf2779c6a05d83139ecedea6284c4beae3dfe72622bfcbca3b",
								"typeString": "literal_string \"Crosslink 2019\""
							},
							"value": "Crosslink 2019"
						},
						"visibility": "private"
					},
					{
						"constant": false,
						"id": 918,
						"name": "complete",
						"nodeType": "VariableDeclaration",
						"scope": 992,
						"src": "91:20:7",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 917,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "91:4:7",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 982,
							"nodeType": "Block",
							"src": "152:369:7",
							"statements": [
								{
									"assignments": [
										924
									],
									"declarations": [
										{
											"constant": false,
											"id": 924,
											"name": "time1",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "158:13:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 923,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "158:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 929,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 926,
													"name": "block",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2927,
													"src": "182:5:7",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_block",
														"typeString": "block"
													}
												},
												"id": 927,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "timestamp",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "182:15:7",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 925,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "174:7:7",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes32_$",
												"typeString": "type(bytes32)"
											},
											"typeName": "bytes32"
										},
										"id": 928,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "174:24:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "158:40:7"
								},
								{
									"assignments": [
										931
									],
									"declarations": [
										{
											"constant": false,
											"id": 931,
											"name": "entropy1",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "204:16:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 930,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "204:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 938,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 935,
														"name": "time1",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 924,
														"src": "250:5:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 933,
														"name": "abi",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2924,
														"src": "233:3:7",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_abi",
															"typeString": "abi"
														}
													},
													"id": 934,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "encodePacked",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "233:16:7",
													"typeDescriptions": {
														"typeIdentifier": "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
														"typeString": "function () pure returns (bytes memory)"
													}
												},
												"id": 936,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "233:23:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											],
											"id": 932,
											"name": "keccak256",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2931,
											"src": "223:9:7",
											"typeDescriptions": {
												"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
												"typeString": "function () pure returns (bytes32)"
											}
										},
										"id": 937,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "223:34:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "204:53:7"
								},
								{
									"assignments": [
										940
									],
									"declarations": [
										{
											"constant": false,
											"id": 940,
											"name": "time2",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "264:13:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 939,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "264:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 945,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 942,
													"name": "block",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2927,
													"src": "288:5:7",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_block",
														"typeString": "block"
													}
												},
												"id": 943,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "timestamp",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "288:15:7",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 941,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "280:7:7",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes32_$",
												"typeString": "type(bytes32)"
											},
											"typeName": "bytes32"
										},
										"id": 944,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "280:24:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "264:40:7"
								},
								{
									"assignments": [
										947
									],
									"declarations": [
										{
											"constant": false,
											"id": 947,
											"name": "entropy2",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "310:16:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 946,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "310:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 954,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 951,
														"name": "time2",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 940,
														"src": "356:5:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 949,
														"name": "abi",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2924,
														"src": "339:3:7",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_abi",
															"typeString": "abi"
														}
													},
													"id": 950,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "encodePacked",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "339:16:7",
													"typeDescriptions": {
														"typeIdentifier": "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
														"typeString": "function () pure returns (bytes memory)"
													}
												},
												"id": 952,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "339:23:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											],
											"id": 948,
											"name": "keccak256",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2931,
											"src": "329:9:7",
											"typeDescriptions": {
												"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
												"typeString": "function () pure returns (bytes32)"
											}
										},
										"id": 953,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "329:34:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "310:53:7"
								},
								{
									"assignments": [
										956
									],
									"declarations": [
										{
											"constant": false,
											"id": 956,
											"name": "target",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "370:14:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 955,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "370:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 972,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										},
										"id": 971,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													},
													"id": 968,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																},
																"id": 959,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 957,
																	"name": "entropy1",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 931,
																	"src": "389:8:7",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "^",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 958,
																	"name": "entropy2",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 947,
																	"src": "400:8:7",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																},
																"src": "389:19:7",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															}
														],
														"id": 960,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "388:21:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 964,
																			"name": "block",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2927,
																			"src": "445:5:7",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_block",
																				"typeString": "block"
																			}
																		},
																		"id": 965,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "number",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "445:12:7",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	],
																	"expression": {
																		"argumentTypes": null,
																		"id": 962,
																		"name": "abi",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2924,
																		"src": "428:3:7",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_abi",
																			"typeString": "abi"
																		}
																	},
																	"id": 963,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"memberName": "encodePacked",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "428:16:7",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
																		"typeString": "function () pure returns (bytes memory)"
																	}
																},
																"id": 966,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "428:30:7",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes_memory_ptr",
																	"typeString": "bytes memory"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bytes_memory_ptr",
																	"typeString": "bytes memory"
																}
															],
															"id": 961,
															"name": "keccak256",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2931,
															"src": "418:9:7",
															"typeDescriptions": {
																"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																"typeString": "function () pure returns (bytes32)"
															}
														},
														"id": 967,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "418:41:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"src": "388:71:7",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												}
											],
											"id": 969,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "387:73:7",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "&",
										"rightExpression": {
											"argumentTypes": null,
											"id": 970,
											"name": "sault",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 916,
											"src": "469:5:7",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "387:87:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "370:104:7"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 980,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 973,
											"name": "complete",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 918,
											"src": "480:8:7",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													},
													"id": 978,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 974,
														"name": "target",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 956,
														"src": "492:6:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 976,
																"name": "_key",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 920,
																"src": "510:4:7",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"id": 975,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "502:7:7",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_bytes32_$",
																"typeString": "type(bytes32)"
															},
															"typeName": "bytes32"
														},
														"id": 977,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "502:13:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"src": "492:23:7",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												}
											],
											"id": 979,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "491:25:7",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"src": "480:36:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 981,
									"nodeType": "ExpressionStatement",
									"src": "480:36:7"
								}
							]
						},
						"documentation": null,
						"id": 983,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "guess",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 921,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 920,
									"name": "_key",
									"nodeType": "VariableDeclaration",
									"scope": 983,
									"src": "131:12:7",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 919,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "131:7:7",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "130:14:7"
						},
						"payable": false,
						"returnParameters": {
							"id": 922,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "152:0:7"
						},
						"scope": 992,
						"src": "116:405:7",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 990,
							"nodeType": "Block",
							"src": "568:26:7",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 988,
										"name": "complete",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 918,
										"src": "581:8:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 987,
									"id": 989,
									"nodeType": "Return",
									"src": "574:15:7"
								}
							]
						},
						"documentation": null,
						"id": 991,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "pass",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 984,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "538:2:7"
						},
						"payable": false,
						"returnParameters": {
							"id": 987,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 986,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 991,
									"src": "562:4:7",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 985,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "562:4:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "561:6:7"
						},
						"scope": 992,
						"src": "525:69:7",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 993,
				"src": "26:570:7"
			}
		],
		"src": "0:597:7"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Encrypt.sol",
		"exportedSymbols": {
			"Encrypt": [
				992
			]
		},
		"id": 993,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 913,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:7"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 992,
				"linearizedBaseContracts": [
					992
				],
				"name": "Encrypt",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 916,
						"name": "sault",
						"nodeType": "VariableDeclaration",
						"scope": 992,
						"src": "47:40:7",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bytes32",
							"typeString": "bytes32"
						},
						"typeName": {
							"id": 914,
							"name": "bytes32",
							"nodeType": "ElementaryTypeName",
							"src": "47:7:7",
							"typeDescriptions": {
								"typeIdentifier": "t_bytes32",
								"typeString": "bytes32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "43726f73736c696e6b2032303139",
							"id": 915,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "71:16:7",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_308c268d533d8ecf2779c6a05d83139ecedea6284c4beae3dfe72622bfcbca3b",
								"typeString": "literal_string \"Crosslink 2019\""
							},
							"value": "Crosslink 2019"
						},
						"visibility": "private"
					},
					{
						"constant": false,
						"id": 918,
						"name": "complete",
						"nodeType": "VariableDeclaration",
						"scope": 992,
						"src": "91:20:7",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 917,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "91:4:7",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 982,
							"nodeType": "Block",
							"src": "152:369:7",
							"statements": [
								{
									"assignments": [
										924
									],
									"declarations": [
										{
											"constant": false,
											"id": 924,
											"name": "time1",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "158:13:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 923,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "158:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 929,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 926,
													"name": "block",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2927,
													"src": "182:5:7",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_block",
														"typeString": "block"
													}
												},
												"id": 927,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "timestamp",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "182:15:7",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 925,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "174:7:7",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes32_$",
												"typeString": "type(bytes32)"
											},
											"typeName": "bytes32"
										},
										"id": 928,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "174:24:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "158:40:7"
								},
								{
									"assignments": [
										931
									],
									"declarations": [
										{
											"constant": false,
											"id": 931,
											"name": "entropy1",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "204:16:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 930,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "204:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 938,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 935,
														"name": "time1",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 924,
														"src": "250:5:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 933,
														"name": "abi",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2924,
														"src": "233:3:7",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_abi",
															"typeString": "abi"
														}
													},
													"id": 934,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "encodePacked",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "233:16:7",
													"typeDescriptions": {
														"typeIdentifier": "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
														"typeString": "function () pure returns (bytes memory)"
													}
												},
												"id": 936,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "233:23:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											],
											"id": 932,
											"name": "keccak256",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2931,
											"src": "223:9:7",
											"typeDescriptions": {
												"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
												"typeString": "function () pure returns (bytes32)"
											}
										},
										"id": 937,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "223:34:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "204:53:7"
								},
								{
									"assignments": [
										940
									],
									"declarations": [
										{
											"constant": false,
											"id": 940,
											"name": "time2",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "264:13:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 939,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "264:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 945,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 942,
													"name": "block",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2927,
													"src": "288:5:7",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_block",
														"typeString": "block"
													}
												},
												"id": 943,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "timestamp",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "288:15:7",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 941,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "280:7:7",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes32_$",
												"typeString": "type(bytes32)"
											},
											"typeName": "bytes32"
										},
										"id": 944,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "280:24:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "264:40:7"
								},
								{
									"assignments": [
										947
									],
									"declarations": [
										{
											"constant": false,
											"id": 947,
											"name": "entropy2",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "310:16:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 946,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "310:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 954,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 951,
														"name": "time2",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 940,
														"src": "356:5:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 949,
														"name": "abi",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2924,
														"src": "339:3:7",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_abi",
															"typeString": "abi"
														}
													},
													"id": 950,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "encodePacked",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "339:16:7",
													"typeDescriptions": {
														"typeIdentifier": "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
														"typeString": "function () pure returns (bytes memory)"
													}
												},
												"id": 952,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "339:23:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											],
											"id": 948,
											"name": "keccak256",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2931,
											"src": "329:9:7",
											"typeDescriptions": {
												"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
												"typeString": "function () pure returns (bytes32)"
											}
										},
										"id": 953,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "329:34:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "310:53:7"
								},
								{
									"assignments": [
										956
									],
									"declarations": [
										{
											"constant": false,
											"id": 956,
											"name": "target",
											"nodeType": "VariableDeclaration",
											"scope": 983,
											"src": "370:14:7",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 955,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "370:7:7",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 972,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										},
										"id": 971,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													},
													"id": 968,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																},
																"id": 959,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 957,
																	"name": "entropy1",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 931,
																	"src": "389:8:7",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "^",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 958,
																	"name": "entropy2",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 947,
																	"src": "400:8:7",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																},
																"src": "389:19:7",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															}
														],
														"id": 960,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "388:21:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 964,
																			"name": "block",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2927,
																			"src": "445:5:7",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_block",
																				"typeString": "block"
																			}
																		},
																		"id": 965,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "number",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "445:12:7",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	],
																	"expression": {
																		"argumentTypes": null,
																		"id": 962,
																		"name": "abi",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2924,
																		"src": "428:3:7",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_abi",
																			"typeString": "abi"
																		}
																	},
																	"id": 963,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"memberName": "encodePacked",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "428:16:7",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
																		"typeString": "function () pure returns (bytes memory)"
																	}
																},
																"id": 966,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "428:30:7",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes_memory_ptr",
																	"typeString": "bytes memory"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bytes_memory_ptr",
																	"typeString": "bytes memory"
																}
															],
															"id": 961,
															"name": "keccak256",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2931,
															"src": "418:9:7",
															"typeDescriptions": {
																"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																"typeString": "function () pure returns (bytes32)"
															}
														},
														"id": 967,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "418:41:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"src": "388:71:7",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												}
											],
											"id": 969,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "387:73:7",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "&",
										"rightExpression": {
											"argumentTypes": null,
											"id": 970,
											"name": "sault",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 916,
											"src": "469:5:7",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "387:87:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "370:104:7"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 980,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 973,
											"name": "complete",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 918,
											"src": "480:8:7",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													},
													"id": 978,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 974,
														"name": "target",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 956,
														"src": "492:6:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 976,
																"name": "_key",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 920,
																"src": "510:4:7",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"id": 975,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "502:7:7",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_bytes32_$",
																"typeString": "type(bytes32)"
															},
															"typeName": "bytes32"
														},
														"id": 977,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "502:13:7",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"src": "492:23:7",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												}
											],
											"id": 979,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "491:25:7",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"src": "480:36:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 981,
									"nodeType": "ExpressionStatement",
									"src": "480:36:7"
								}
							]
						},
						"documentation": null,
						"id": 983,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "guess",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 921,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 920,
									"name": "_key",
									"nodeType": "VariableDeclaration",
									"scope": 983,
									"src": "131:12:7",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 919,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "131:7:7",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "130:14:7"
						},
						"payable": false,
						"returnParameters": {
							"id": 922,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "152:0:7"
						},
						"scope": 992,
						"src": "116:405:7",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 990,
							"nodeType": "Block",
							"src": "568:26:7",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 988,
										"name": "complete",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 918,
										"src": "581:8:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 987,
									"id": 989,
									"nodeType": "Return",
									"src": "574:15:7"
								}
							]
						},
						"documentation": null,
						"id": 991,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "pass",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 984,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "538:2:7"
						},
						"payable": false,
						"returnParameters": {
							"id": 987,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 986,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 991,
									"src": "562:4:7",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 985,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "562:4:7",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "561:6:7"
						},
						"scope": 992,
						"src": "525:69:7",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 993,
				"src": "26:570:7"
			}
		],
		"src": "0:597:7"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.798Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Encrypt.json
// module id = 1032
// module chunks = 0